module.exports = __webpack_public_path__ + "static/media/game-logs-active-icon.2fd50be9.svg";